import { GRANT_STAGES, grantStageConfig } from './grantStages';

export const SORT_OPTIONS = [
  { value: 'deadline', label: 'Soonest deadline' },
  { value: 'status', label: 'Status' },
  { value: 'owner', label: 'Owner A–Z' },
  { value: 'funder', label: 'Funder A–Z' },
  { value: 'requested', label: 'Highest requested' },
  { value: 'awarded', label: 'Highest awarded' },
  { value: 'name', label: 'Name A–Z' },
];

export const DEFAULT_SORT = 'deadline';

export const DEADLINE_OPTIONS = [
  { value: '7', label: 'Next 7 days' },
  { value: '30', label: 'Next 30 days' },
  { value: '90', label: 'Next 90 days' },
  { value: 'overdue', label: 'Overdue' },
];

export const SEARCH_RANSACK_KEY = 'name_or_funder_or_organization_name_cont';

const FILTER_RANSACK_KEYS = {
  status: 'stage_in',
  owner: 'owner_team_membership_id_in',
  funder: 'funder_in',
};

export const buildGrantFilters = ({ owners = [], funders = [], renderDeadline }) => [
  {
    key: 'status',
    label: 'Status',
    options: GRANT_STAGES.map((stage) => ({ value: stage, label: grantStageConfig(stage).label })),
  },
  {
    key: 'owner',
    label: 'Owner',
    type: 'search',
    options: owners.map((owner) => ({ value: String(owner.value), label: owner.label })),
  },
  {
    key: 'funder',
    label: 'Funder',
    type: 'search',
    options: funders.map((funder) => ({ value: funder, label: funder })),
  },
  { key: 'deadline', label: 'Deadline', options: DEADLINE_OPTIONS, render: renderDeadline },
];

export const buildGrantQuery = (searchTerm, filterValues) => {
  const q = {};
  if (searchTerm) q[SEARCH_RANSACK_KEY] = searchTerm;
  Object.entries(FILTER_RANSACK_KEYS).forEach(([key, ransackKey]) => {
    const picked = filterValues[key];
    if (picked && picked.length > 0) q[ransackKey] = picked;
  });
  const due = (filterValues.deadline || [])[0] || null;
  return { q, due };
};
